import * as React from 'react'
import { HybridSettingsPageResourceContainer } from './HybridSettingsPageResourceContainer'
import Tooltip from '@mulesoft/anypoint-components/lib/Tooltip'

export type Props = {
  option: any,
}

export const HybridSettingsPageResourceTooltip = (props: Props) => {
  return (
    <div>
      <Tooltip content={props.option.label} position={'bottom'}>
        <HybridSettingsPageResourceContainer option={props.option} ellipsis="truncate-ellipsis-hybrid"/>
      </Tooltip>
    </div>
  )
}
